import React, { useState, useEffect } from "react";
import { connect, useSelector, useDispatch } from "react-redux";

import StarRatings from "react-star-ratings";
import UnionIcon from "../../../assets/images/icons/Union_5.svg";
import CatalogJewelryDataService from "../../../services/catalog-jewelry.service";
import { NotificationManager } from "react-notifications";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import {
  setManageInventoryVendorId,
  setManageTabName,
} from "./../../../actions/Community/ManageInventory";
import {
  Button,
  Empty,
  Modal,
  Radio,
  Select,
  Spin,
  Switch,
  Table,
  Tooltip,
} from "antd";
import communityVendorService from "../../../services/community-vendor.service";
import LoginDataService from "../../../services/login.service";

const { Option } = Select;

export const ManageCollection = (props) => {
  const { t } = useTranslation();
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const loginDetials = useSelector((state) => state.loginReducer);
  const [loading, setLoading] = useState(false);
  const [filterValue, setFilterValue] = useState("All Vendors");
  const [collectionList, setCollectionList] = useState([]);

  const [brandList, setBrandList] = useState([]);
  const [dealerId, setDealerId] = useState(0);
  const [VendorDrpList, setVendorDrpList] = useState([]);
  const [activeExpRow, setActiveExpRow] = useState();
  const [image, setImage] = useState({});
  const [isImageModal, setIsImageModal] = useState(false);
  const [selectedColumnId, setSelectedColumnId] = useState(0);
  const [rowDetails, setRowDetails] = useState([]);
  const [indexingStatus, setIndexingStatus] = useState("");

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          handleCatalogBindDataForVendorCount(
            loginDetials.loginDetials.responseData.dealerId
          );
          handleGetCollectionsList(
            loginDetials.loginDetials.responseData.dealerId,
            filterValue
          );
          handleGetBrandListbyDealer(
            loginDetials.loginDetials.responseData.dealerId
          );
          fetchIndexingStatus(loginDetials.loginDetials.responseData.dealerId);
        }
      }
    }
  }, []);

  const fetchIndexingStatus = async (id) => {
    try {
      const response = await LoginDataService.GetIndexingStatus({
        dealerId: id,
      });
      if (response.data && response.data.responseData) {
        setIndexingStatus(response.data.responseData.indexingStatus || "");
      }
    } catch (error) {
      console.log("Error fetching indexing status:", error);
    }
  };

  const handleGetBrandListbyDealer = (id) => {
    try {
      let inputData = {
        dealerID: id,
      };
      setLoading(true);
      CatalogJewelryDataService.GetBrandListbyDealer(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          if (message === "Success") {
            setBrandList(responseData);
          } else {
            setBrandList([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleCatalogBindDataForVendorCount = (id) => {
    try {
      let inputData = {
        dealerID: id.toString(),
      };

      CatalogJewelryDataService.CatalogBindDataForVendorCount(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData.allCountList;
          if (message === "Success") {
            setVendorDrpList(responseData);
          } else {
            setVendorDrpList([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetCollectionsList = async (id, filterValue) => {
    try {
      let inputData = {
        dealerID: id.toString(),
        BrandTypeID: filterValue,
        sortBy: "",
      };
      setLoading(true);
      await CatalogJewelryDataService.CatalogBindDataForVendor(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData =
            response.data.responseData.catalogBindDataForVendorList;
          setLoading(false);
          if (message === "Success") {
            if (responseData) {
              responseData.forEach(r => {
                if(r.isVendorEnabled == false){
                  r.status = 'Access disabled'
                }
              });
              setCollectionList(responseData);
              setRowDetails(responseData[0]);
              handleShowDataToRightNew(responseData[0]);
            } else {
              setCollectionList([]);
              setRowDetails([]);
            }
            setLoading(false);
          } else {
            setCollectionList([]);
            setRowDetails([]);
          }
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    } catch (error) {
      setLoading(false);
    }
  };

  const handleIsSelectChange = (saveRow) => {
    try {
      let inputData = {
        dealerID: dealerId.toString(),
        visibility: saveRow.visibility.toString(),
        vendorID: saveRow.dealerID.toString(),
      };
      CatalogJewelryDataService.UpdateVisibility(inputData)
        .then((response) => {
          let message = response.data.message;
          if (message === "Success") {
            NotificationManager.success(t("Record Updated Successfully."));
            handleGetCollectionsList(dealerId, filterValue);
            fetchIndexingStatus(dealerId);
          } else {
            NotificationManager.error(t("Record Not Updated."));
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleCollectionVendorEnable = (saveRow) => {
    try {
      let inputData = {
        dealerID: dealerId.toString(),
        manuID: saveRow.dealerID.toString(),
        isGrant: saveRow.isGrant.toString(),
      };
      CatalogJewelryDataService.UpdateAcceptCollections(inputData)
        .then((response) => {
          let message = response.data.message;
          if (message === "Success") {
            NotificationManager.success(t("Record Updated Successfully."));
            handleGetCollectionsList(dealerId, filterValue);
          } else {
            NotificationManager.error(t("Record Not Updated."));
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handlePricingVendorChange = (saveRow) => {
    try {
      let inputData = {
        dealerID: dealerId.toString(),
        pricing: saveRow.pricing.toString(),
        vendorID: saveRow.dealerID.toString(),
      };
      CatalogJewelryDataService.UpdatePricing(inputData)
        .then((response) => {
          let message = response.data.message;

          if (message === "Success") {
            NotificationManager.success(t("Record Updated Successfully."));
            handleGetCollectionsList(dealerId, filterValue);
          } else {
            NotificationManager.error(t("Record Not Updated."));
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleUpdateOverride = (saveRow) => {
    try {
      let inputData = {
        dealerID: dealerId.toString(),
        vendorID: saveRow.dealerID.toString(),
        overrideText: (saveRow.markupOverride !== undefined && saveRow.markupOverride !== "" ? saveRow.markupOverride : saveRow.override).toString(),
        overrideenebled: saveRow.overrideEnabled,
      };
      CatalogJewelryDataService.UpdateOverride(inputData)
        .then((response) => {
          let message = response.data.message;
          if (message === "Success") {
            NotificationManager.success(t("Record Updated Successfully."));
            handleGetCollectionsList(dealerId, filterValue);
          } else {
            NotificationManager.error(t("Record Not Updated."));
            handleGetCollectionsList(dealerId, filterValue);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnChange = (row, e, name) => {
    if (name === "visibility") {
      const temp = collectionList.map((x) => {
        if (x.designerID === row.designerID) {
          return { ...x, visibility: e };
        } else return x;
      });
      let saveRow = temp.filter((obj) => obj.designerID == row.designerID)[0];
      setCollectionList(temp);
      handleIsSelectChange(saveRow);
    }
    if (name === "pricing") {
      const temp = collectionList.map((x) => {
        if (x.designerID === row.designerID) {
          return { ...x, pricing: e };
        } else return x;
      });
      let saveRow = temp.filter((obj) => obj.designerID == row.designerID)[0];
      setCollectionList(temp);
      handlePricingVendorChange(saveRow);
    }
    if (name === "isGrant") {
      const temp = collectionList.map((x) => {
        if (x.designerID == row.designerID) {
          return { ...x, isGrant: e };
        } else return x;
      });
      let saveRow = temp.filter((obj) => obj.designerID == row.designerID)[0];
      setCollectionList(temp);
      handleCollectionVendorEnable(saveRow);
    }
    if (name === "overrideEnabled") {
      const temp = collectionList.map((x) => {
        if (x.designerID === row.designerID) {
          //debugger;
          return {
            ...x,
            overrideEnabled: e.target.value === "percentage",
          };
        } else return x;
      });
      setCollectionList(temp);
      setRowDetails({
        ...rowDetails,
        overrideEnabled: e.target.value === "percentage",
      });
    }
    if (name === "markupOverride") {
      if (Number(e.target.value) >= 0 && Number(e.target.value) <= 1000) {
        const temp = collectionList.map((x) => {
          if (x.designerID === row.designerID) {
            //debugger;
            return {
              ...x,
              override: e.target.value,
            };
          } else return x;
        });
        setCollectionList(temp);
        setRowDetails({
          ...rowDetails,
          markupOverride: e.target.value,
        });
      } else {
        e.preventDefault();
      }
    }
  };

  const onKeyPressEvent = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    if (!new RegExp("[0-9]").test(keyValue)) event.preventDefault();
    return;
  };

  const handleOnSelectChange = (e, name) => {
    setFilterValue(e);
    handleGetCollectionsList(dealerId, e);
  };

  const modifiedData = collectionList?.map((item) => ({
    ...item,
    key: item.designerID,
  }));

  const handleOpenImageModal = (row) => {
    setImage(row);
    setIsImageModal(true);
  };

  const handleCloseImageModal = (row) => {
    setImage({});
    setIsImageModal(false);
  };

  const handleViewProfile = (id) => {
    navigate("/vendorProfile", {
      state: {
        key: "Profile",
        id: id || rowDetails.dealerID,
        pageType: "",
      },
    });
  };

  const handleCollection = (row) => {
    // navigate("/myvendors");
    const params = new URLSearchParams({
      dealerID: row?.dealerID || "",
      designerName: row?.designerName || "",
    });
    navigate(`/manageCollection?${params.toString()}`);
  };

  const handleProducts = async (id) => {
    await handleDispatchTabName(
      rowDetails.isEnable == "true" ? "Manage" : "View"
    );
    await navigate("/vendorProfile", {
      state: {
        key: "Inventory",
        id: id || rowDetails.dealerID,
      },
    });
  };

  const handleSetRowDetails = (row) => {
    setRowDetails(row);
    dispatch(setManageInventoryVendorId(row.dealerID));
  };

  const openInNewTab = (Url) => {
    let url = Url;
    if (Url.includes("https")) {
      window.open(url, "_blank");
    } else if (Url.includes("http")) {
      window.open(url, "_blank");
    } else {
      window.open("https://" + url, "_blank");
    }
  };

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const onSelectChange = (newSelectedRowKeys, row) => {
    handleSetRowDetails(row[0]);
    let tempData = modifiedData.filter((x) => x.key == newSelectedRowKeys[0]);
    setSelectedRowKeys(newSelectedRowKeys);
    localStorage.setItem("vendorDataForCollection", tempData[0].designerName);
  };

  const handleShowDataToRightNew = (record) => {
    let inputData = {
      vendorID: record.dealerID.toString(),
      dealerID: dealerId.toString(),
      isEnable: (record.isEnable ?? true).toString(),
    };

    setSelectedColumnId(record.dealerID);
    dispatch(setManageInventoryVendorId(record.dealerID));
    communityVendorService
      .ShowDataToRightNew(inputData)
      .then((response) => {
        let message = response.data.message;
        let responseData = response.data.responseData[0];
        if (message === "Success") {
          if (responseData) {
            setRowDetails(responseData);
          } else {
            setRowDetails({});
          }
        } else {
          setRowDetails({});
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {});
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const handleDispatchTabName = (name) => {
    dispatch(setManageTabName(name));
  };

  return (
    <div className="form__fields">
      <div className="row magento__mapping permission__section">
        <div className="col-md-12">
          <div className="heading__block  d-flex-sm-block">
            <h4 className="workarea__heading mt-0 mb-0">
              {t("Vendors")}
              {"(" + collectionList.length + ")"}
              {indexingStatus === "InProcess" && (
                <Tooltip title={t("Indexing in progress")}>
                  <span className="indexing-symbol ml-2" style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "20px",
                    height: "20px",
                    backgroundColor: "#1883b8",
                    color: "#fff",
                    borderRadius: "50%",
                    fontSize: "12px",
                    fontWeight: "bold",
                    marginLeft: "8px"
                  }}>
                    i
                  </span>
                </Tooltip>
              )}
            </h4>
            <div className={"input__block col-md-4 d-flex"}>
              <Select
                name="filterValue"
                placeholder={t("Select Collections")}
                optionFilterProp="children"
                className="border__grey"
                onChange={(e) => handleOnSelectChange(e)}
                value={filterValue}
              >
                {VendorDrpList?.map((item) => {
                  return (
                    <Option value={item.allCountID}>{item.allCountData}</Option>
                  );
                })}
              </Select>
            </div>
          </div>
        </div>

        <div
          className={
            selectedColumnId !== 0
              ? "col-lg-9 divForm vendors-section"
              : "col-lg-12"
          }
        >
          <div className="divForm">
            <Spin spinning={loading} size="large">
              <div className="table__scroll mobile__topspace">
                <Table
                  pagination={{
                    size: "small",
                    showSizeChanger: true,
                    responsive: true,
                  }}
                  className="vdiamond__table"
                  columns={[
                    {
                      title: (
                        <Tooltip title={t("Vendor Name")}>
                          {t("Vendor Name")}
                        </Tooltip>
                      ),
                      ellipsis: true,
                      dataIndex: "designerName",
                      width: "230px",
                      render: (item, row) => {
                        return (
                          <React.Fragment>
                            <span
                              onClick={() => handleViewProfile(row?.dealerID)}
                              className="linkText"
                            >
                              {row.designerName}
                            </span>
                          </React.Fragment>
                        );
                      },
                      sorter: (a, b) =>
                        a.designerName.localeCompare(b.designerName),
                      showSorterTooltip: false,
                    },

                    {
                      title: (
                        <Tooltip title={t("Status")}>{t("Status")}</Tooltip>
                      ),
                      ellipsis: true,
                      dataIndex: "status",
                      showSorterTooltip: false,
                      sorter: (a, b) => {},
                      // width: 100,
                      sorter: (a, b) => a.status.localeCompare(b.status),
                    },
                    {
                      title: (
                        <Tooltip title={t("Override")}>{t("Override")}</Tooltip>
                      ),
                      ellipsis: true,
                      dataIndex: "override",
                      key: "override",
                      showSorterTooltip: false,
                      sorter: (a, b) => a.override - b.override,
                      render: (index, row) => (
                        <span>
                          {row.overrideEnabled == false
                            ? "Disabled"
                            : row.override + "%"}
                        </span>
                      ),
                    },

                    {
                      title: (
                        <Tooltip title={t("Collections")}>
                          {t("Collections")}
                        </Tooltip>
                      ),
                      ellipsis: true,
                      dataIndex: "totalCollection",
                      render: (item, row) => {
                        return (
                          <React.Fragment>
                            <div
                              className="infoicon__div"
                              onClick={() => handleCollection(row)}
                            >
                              <span className="linkText">
                                {" "}
                                {row?.totalCollection}
                              </span>
                            </div>
                          </React.Fragment>
                        );
                      },
                      sorter: (a, b) => a.totalCollection - b.totalCollection,
                      showSorterTooltip: false,
                    },
                    {
                      title: <Tooltip title={t("Items")}>{t("Items")}</Tooltip>,
                      ellipsis: true,
                      dataIndex: "items",
                      render: (item, row) => {
                        return (
                          <React.Fragment>
                            <div
                              className="infoicon__div"
                              onClick={() => handleProducts(row?.dealerID)}
                            >
                              <span className="linkText"> {row?.items}</span>
                            </div>
                          </React.Fragment>
                        );
                      },
                      sorter: (a, b) => a.items - b.items,
                      showSorterTooltip: false,
                    },
                    {
                      title: (
                        <Tooltip title={t("Pricing")}>{t("Pricing")}</Tooltip>
                      ),
                      ellipsis: true,
                      dataIndex: "pricing",
                      render: (item, row) => (
                        <div className="action__btns">
                          <Switch
                            name="pricing"
                            checkedChildren={t("Yes")}
                            unCheckedChildren={t("No")}
                            checked={row.pricing}
                            disabled={row.isVendorEnabled == false}  
                            onChange={(e) => handleOnChange(row, e, "pricing")}
                          />
                        </div>
                      ),
                    },
                    {
                      title: (
                        <span className="font__bold">
                          {t("Visibility")}

                          <Tooltip
                            placement="right"
                            className="ml-1"
                            title={t(
                              "This shows the collection on your own MasterLink, for preview purposes"
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </span>
                      ),
                      dataIndex: "visibility",
                      render: (item, row) => (
                        <div className="action__btns">
                          <Switch
                            name="visibility"
                            checkedChildren={t("Yes")}
                            unCheckedChildren={t("No")}
                            checked={row.visibility}
                            disabled={row.isVendorEnabled == false}  
                            onChange={(e) =>
                              handleOnChange(row, e, "visibility")
                            }
                          />
                        </div>
                      ),
                    },
                  ]}
                  onRow={(record, recordIndex) => ({
                    onClick: (event) => {
                      handleShowDataToRightNew(record);
                    },
                  })}
                  rowClassName={(record) =>
                    record.dealerID == selectedColumnId ? "row-active" : ""
                  }
                  onChange={(pagination, filters, sorters) => {
                    document
                      .getElementsByClassName("content__area")[0]
                      .scroll(0, 0);
                  }}
                  dataSource={modifiedData}
                />
              </div>
            </Spin>
          </div>
        </div>
        {selectedColumnId !== 0 ? (
          <div className="col-lg-3 col-md-3">
            <div className="right__section">
              <div className="profile__block">
                <Link
                  to={"/vendorProfile"}
                  state={{
                    key: "Profile",
                    id: selectedColumnId,
                  }}
                >
                  <span className="linkText">
                    {rowDetails.designerName ? rowDetails.designerName : null}
                  </span>
                </Link>
                <div className="logoImg__block p-0">
                  <img src={rowDetails.src ? rowDetails.src : null} />
                </div>
                <p className="activeFrom">
                  {" "}
                  {rowDetails.vendorStatus
                    ? rowDetails.vendorStatus
                    : null} | {rowDetails.activity
                      ? rowDetails.activity.split(' @ ')[0]
                        ? moment(rowDetails.activity.split(' @ ')[0], 'DD/MM/YYYY').format('MM/DD/YYYY') + ' @ ' + rowDetails.activity.split(' @ ')[1]
                        : rowDetails.activity
                      : null}{" "}
                </p>

                <div className="star-ratings mb-2">
                  <p className="mb-0"> {t("Data Ratings")} </p>
                  <StarRatings
                    rating={rowDetails.ratingCount}
                    starRatedColor="#1883b8"
                    starDimension="18px"
                    starSpacing="0px"
                    numberOfStars={5}
                  />
                </div>
              </div>

              <div className="links__block">
                <ul>
                  <li>
                    <Link
                      to={"/vendorProfile?isShow=true"}
                      state={{
                        key: "Profile",
                        id: selectedColumnId,
                        checkOutOfNetwork: false,
                      }}
                    >
                      <i class="fa fa-address-book-o" aria-hidden="true"></i>{" "}
                      {t("View Profile")}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={"/vendorProfile?isShow=true"}
                      state={{
                        key: "Conversation",
                        id: selectedColumnId,
                        checkOutOfNetwork: false,
                      }}
                    >
                      <i class="fa fa-comments-o" aria-hidden="true"></i>{" "}
                      {t("Conversation")}
                    </Link>
                  </li>
                  {window.location.pathname !== "/outOfNetwork" && (
                    <>
                      {rowDetails.vendorStatus !== "Out of Network" &&
                      rowDetails.vendorStatus !== "Profile Only" ? (
                        <li
                          onClick={() =>
                            handleDispatchTabName(
                              rowDetails.isEnable == "true" ? "Manage" : "View"
                            )
                          }
                        >
                          <Link
                            to={"/vendorProfile?isShow=true"}
                            state={{
                              key: "Inventory",
                              id: selectedColumnId,
                              checkOutOfNetwork: false,
                              bindActivePageName:
                                props?.type == "Popular"
                                  ? "Popular"
                                  : props?.type == "Recently Updated"
                                  ? "Recently Updated"
                                  : props?.type == "Archived Vendor"
                                  ? "Archived Vendor"
                                  : props?.type == "New"
                                  ? "New"
                                  : props?.type == "Pending Requests"
                                  ? "Pending Requests"
                                  : props?.type == "Out Of Network"
                                  ? "Out Of Network"
                                  : "Network",
                            }}
                          >
                            <i class="fa fa-diamond" aria-hidden="true"></i>{" "}
                            {rowDetails.isEnable == "true"
                              ? t("Manage Inventory")
                              : t("View Inventory")}
                          </Link>
                        </li>
                      ) : null}
                    </>
                  )}

                  <li>
                    <Link
                      to={"/vendorProfile?isShow=true"}
                      state={{
                        key: "Location",
                        id: selectedColumnId,
                        checkOutOfNetwork: false,
                      }}
                    >
                      <i class="fa fa-globe" aria-hidden="true"></i>{" "}
                      {t("View Location")}
                    </Link>
                    <a href="#"></a>
                  </li>
                </ul>
                <hr />
              </div>
              <p className="mb-2">
                <label className="fontSize_12px">{t("Updated Date")} : </label>
                <span className="mx-2">
                  {moment(rowDetails.lastUpdatedDate).format("MM/DD/YYYY")}
                </span>
              </p>
              <label className="fontSize_12px">
                {t("MarkUp Overrride")} :{" "}
              </label>
              <div className="d-flex">
                <div className="radio__block mx-2">
                  <Radio
                    checked={rowDetails.overrideEnabled == false}
                    onChange={(e) =>
                      handleOnChange(rowDetails, e, "overrideEnabled")
                    }
                    value="disabled"
                    option="Disable"
                  >
                    {t("Disable")}
                  </Radio>
                </div>
                <div className="radio__block">
                  <Radio
                    checked={rowDetails.overrideEnabled == true}
                    onChange={(e) =>
                      handleOnChange(rowDetails, e, "overrideEnabled")
                    }
                    value="percentage"
                    option="Percentage"
                  >
                    {t("Percent")}
                  </Radio>
                </div>
              </div>

              <div className="input__block mb-2">
                <div className="input__conten d-flex">
                  <input
                    type="text"
                    onKeyPress={onKeyPressEvent}
                    step="1"
                    min="0"
                    max="1000"
                    disabled={
                      rowDetails.overrideEnabled == false ? true : false
                    }
                    style={{ width: "80px" }}
                    onChange={(e) => {
                      e.target.value = e.target.value.slice(0, 3);
                      handleOnChange(rowDetails, e, "markupOverride");
                    }}
                    value={
                      rowDetails.overrideEnabled == false
                        ? ""
                        : rowDetails.markupOverride === undefined
                        ? rowDetails.override
                        : rowDetails.markupOverride !== "" ||
                          rowDetails.markupOverride === ""
                        ? rowDetails.markupOverride
                        : rowDetails.override
                    }
                    className={
                      rowDetails.overrideEnabled == false ? "disabled" : ""
                    }
                  />
                  <span className="ml-1 mr-2 mt-2">%</span>
                  <div className="">
                    <div className="save__btn">
                      <Button
                        onClick={() => {
                          handleUpdateOverride(rowDetails);
                        }}
                      >
                        {t("Save")}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="retailer__dtls mb-4">
                <p> {rowDetails.dealerName ? rowDetails.dealerName : null} </p>
                <a href={`mailto:${rowDetails.designerEmail}`}>
                  {" "}
                  {rowDetails.designerEmail
                    ? rowDetails.designerEmail
                    : null}{" "}
                </a>
                <p>
                  {" "}
                  {rowDetails.dealerPhone ? rowDetails.dealerPhone : null}{" "}
                </p>
                <span className="linkText" onClick={() => openInNewTab(rowDetails.website)}>
                  {" "}
                  {rowDetails.website}
                </span>
                <hr />
              </div>
            </div>
          </div>
        ) : null}
        <Modal
          title={t("Vendor Details")}
          className="modalvdiamond__section"
          centered
          visible={isImageModal}
          onOk={handleCloseImageModal}
          onCancel={handleCloseImageModal}
          footer={[
            <Button
              key="back"
              className="primary-btn"
              onClick={handleCloseImageModal}
            >
              {t("Cancel")}
            </Button>,
          ]}
        >
          <div className="row">
            <div className="col-md-6">
              {image.dealersImage == "" ? (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              ) : (
                <img
                  style={{ width: "100%" }}
                  src={image.dealersImage}
                  alt=""
                />
              )}
            </div>
            <div className="col-md-6">
              <p className="subheading">{image.designerName}</p>
              <a href={`mailto:${image.designerEmail}`} className="linkText">
                {image.designerEmail}
              </a>
              <p>
                {" "}
                <StarRatings
                  rating={Number(image.ratingCount)}
                  starRatedColor="#1883b8"
                  starDimension="18px"
                  starSpacing="0px"
                  numberOfStars={5}
                />
              </p>
              <p>{image.dealerPhone}</p>
              <p>{image.activity}</p>
              <p>{image.tagName}</p>
              <p onClick={() => openInNewTab(image.website)}>{image.website}</p>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ManageCollection);
